
import { useLocation, useNavigate } from 'react-router-dom'
import ProfileItem from 'components/ProfileItem'
import { useEffect, useState } from 'react'
import Loader from 'components/Loader'
import ErrorModal from './ErrorModal'
import { POST } from 'api/request'
import * as url from 'api/urls'
import './index.scss'

type PreviousPages = 'explainer' | 'dashboard'

const QrReader = () => {
  const [isListVisible, setListVisible] = useState<boolean>(false)
  const [data, setData] = useState<qr.QRResponse | null>(null)
  const [modal, setModal] = useState<boolean>(false)
  const { pathname, search } = useLocation()
  const navigate = useNavigate()

  const checkPreviousPage = (): PreviousPages => {
    const query = new URLSearchParams(search)
    const previousPage = query.get('from')
    return (previousPage || 'dashboard') as PreviousPages
  }

  const previousPage = checkPreviousPage()

  useEffect(() => {
    const fetchBoards = async () => {
      const hash = pathname.split('/qr/')[1]

      try {
        const response = await POST(url.qrscan, { body: { code: hash } })

        if (response.ok) {
          setData(response.data)
          const boards = response.data.data.boards
          const id = response.data.data.id

          if (boards.length === 1) {
            const boardId = boards[0].id
            if (previousPage === "explainer") {
              alert('ten QR jest zajęty')
            } else if (boards[0].is_published) {
              navigate(`/profile/${boardId}?from=qr`)
            } else {
              navigate(`/unpublished/${id}`)
            }

          } else if (boards.length > 1) {
            previousPage === "explainer" ? alert('ten QR jest zajęty') : setListVisible(true)
          } else {
            previousPage === "explainer" ? navigate(`/addprofile/${id}/add`) : navigate(`/explainer/${id}`)
          }
        } else {
          setModal(true)
          throw new Error('Failed to fetch qr')
        }
      } catch (err) {
        console.error(err)
      }
    }
    fetchBoards()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  console.log(data)
  return (
    <>
      {modal && <ErrorModal />}
      {isListVisible && data
        ? <div className="boardsList">
          <div className="boardsList__head">
            <h1>Którą tablicę chcesz wyświetlić?</h1>
          </div>
          <div className="boardsList__body">

            {data.data.boards.map(board => (
              (board.isOwned || board.is_published) && (
                <ProfileItem
                  id={board.id}
                  key={board.id}
                  img={board.img ? board.img : undefined}
                  name={board.name}
                  action={() => {
                    navigate(`/profile/${board.id}?from=qr`)
                  }}
                />
              )
            ))}
          </div>
        </div>
        : <Loader type="full" />}
    </>)
}

export default QrReader